import React from "react";
import {useAppStore} from "../../../common/app.store.consumer";
import { ReportChartComponent } from "../types/report.chart.component";
import ReportChartSpiderWeb from "../components/report.chart.spiderweb";

const ReportDetails: React.FC<ReportChartComponent> = useAppStore()((props: ReportChartComponent) => {
	const userStore = props.appStore.userStore;

	return (
		<>
			<h2 className="cih-h2 cih-mb-1 cih-hide-print">My professional profile</h2>
			<div className="cih-justify-between cih-intro-txt">
				{userStore.isMember ? (
					<div className="cih-txt-lead">
						<p>
							The professional standards self-assessment report will help identify your strengths and areas where you could improve to drive your professional development. Your profile and
							tailored report will also highlight some simple activities that you can do to quickly build your knowledge, stay connected with others from across the sector and get the most
							from your CIH membership.
						</p>
						<h3 className="cih-h2 cih-mb-1">Your report and outcomes</h3>
						<p>Find your report below and a selection of resources tailored to you to help develop your knowledge and skills.</p>
					</div>
				) : (
					<div className="cih-txt-lead">
						<p>
							The CIH professional standards build on seven characteristics that have been developed, tested and refined to enable you to reflect on and think about your related professional
							development needs. They're relevant for everyone who works in housing, across all tenures, whatever your role or specialism.
						</p>
						<h3 className="cih-h3">The characteristics are:</h3>
						<p>Knowledgeable, Integrity, Ethical, Inclusive, Advocate, Leadership and Skilled.</p>
						<p>
							We’ve put together a sample self-assessment so you can find out how you match up to the standards. CIH members get access to a more comprehensive version which provides an
							in-depth personalised report offering tailored content and targeted professional development activities.
						</p>
						<p>
							Become a member today to get full access to the self-assessment so you can show your dedication to the sector, develop your behaviours and make positive changes to the way you
							work.
						</p>
					</div>
				)}
				<div className="cih-chart-spider-wrapper">
					<ReportChartSpiderWeb isPdf={false} />
				</div>
			</div>
		</>
	);
});

export default ReportDetails;
